import { createSignal } from '@verclam/pulsar';

type SubjectToArchive = { subjectId: number; isArchived: boolean };

/** `null` when no archival change awaits confirmation; otherwise the dossier and its current state. */
const subjectToArchiveSignal = createSignal<SubjectToArchive | null>(null);

export const openSubjectToArchive = (subjectId: number, isArchived: boolean): void => {
	subjectToArchiveSignal.value = { subjectId, isArchived };
};

export const closeSubjectToArchive = (): void => {
	subjectToArchiveSignal.value = null;
};

export default subjectToArchiveSignal;
